import { Injectable } from '@angular/core';
import { Models } from '@ibexfusion/models';

import { RestProvider, RestService } from '../rest/rest.service';
import { RestfulService } from '../rest/restful';

@Injectable()
export class GroupHasProfileService extends RestfulService<Models.GroupHasProfile> {

  constructor(private restService: RestService) {
    super(Models.GroupHasProfile);
    super.init();
  }

  public createProvider(): RestProvider {
    return this.restService.createProvider('group-has-profiles');
  }

}
